import { useMyUser } from '@consigli/hooks';

import { getMeetingRole, type MeetingRole } from '../utils/transcript-quality';

import type { Meeting } from '../utils/export-types';

/** Whether the signed-in user organizes the meeting or takes part in it. */
export const useMeetingRole = (meeting: Pick<Meeting, 'participants'>): MeetingRole | null => {
  const { user } = useMyUser();
  return getMeetingRole(meeting.participants, user.email);
};
